"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendDataLayer = void 0;
const sendDataLayer = () => {
    const getInputValue = (selector) => {
        const input = document.querySelector(selector);
        return input === null || input === void 0 ? void 0 : input.value.trim();
    };
    const eventValue = getInputValue('input[name="sm_eventName"]');
    const nameValue = getInputValue('input[name="sm_formName"]');
    const formElement = document.querySelector('form[data-gtmemail="true"]');
    const emailValue = formElement ? getInputValue('form[data-gtmemail="true"] input[name="sm_email"]') : undefined;
    if (eventValue && nameValue) {
        const dataLayerObject = Object.assign({ event: eventValue, formName: nameValue }, (emailValue ? { email: emailValue } : {}));
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(dataLayerObject);
    }
};
exports.sendDataLayer = sendDataLayer;
